import { render, staticRenderFns } from "./referral-program.vue?vue&type=template&id=d99dba2a&"
import script from "./referral-program.vue?vue&type=script&lang=ts&"
export * from "./referral-program.vue?vue&type=script&lang=ts&"
import style0 from "./referral-program.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports